<template>
  <div class="container">
    <h2 class="text-center hidden-sm hidden-xs">
      <i class="fa fa-globe"></i> Dashboard, profile and activity summary
    </h2>
    <div class="col-sm-12 remove-margins">
      <div class="col-sm-10 col-sm-offset-1">
        <hr
          style="margin-top: 0px; margin-bottom: 0px"
          class="hidden-xs hidden-sm"
        />
      </div>
      <div class="col-md-8 hidden-xs hidden-sm">
        <h3 class="text-center text-muted" style="margin-bottom: 0px">
          Feedback and Performance
        </h3>
        <FeedbackAndPerformance
          style="margin-bottom: 20px"
        ></FeedbackAndPerformance>
      </div>
      <div class="col-md-4 hidden-xs hidden-sm">
        <h3 class="text-center text-muted" style="margin-bottom: 5px">
          Shortcuts
        </h3>
        <Shortcuts></Shortcuts>
      </div>
    </div>

    <h3 class="text-center hidden-md hidden-lg">
      <i class="fa fa-globe"></i> Dashboard, profile and activity summary
    </h3>
    <ul class="nav nav-tabs hidden-md hidden-lg">
      <router-link
        active-class="active"
        tag="li"
        to="/dashboard/feedback-performance"
      >
        <a>Performance</a>
      </router-link>

      <router-link active-class="active" tag="li" to="/dashboard/shortcuts">
        <a>Shortcuts</a>
      </router-link>
    </ul>

    <div class="tab-content hidden-md hidden-lg">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import FeedbackAndPerformance from "./FeedbackAndPerformance";
import Shortcuts from "./Shortcuts";
import router from "../../router";
import store from "../../data/store";

const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "dashboard",
  data() {
    return {};
  },
  computed: {
    sitterIdComp: function () {
      if (store.getters.SitterId != null) {
        return "/sitter/" + store.getters.SitterId;
      }
    },
  },
  components: {
    FeedbackAndPerformance,
    Shortcuts,
  },
  updated() {
    this.$ga.page(this.$router);
    //    $zopim(function (){
    //       $zopim.livechat.sendVisitorPath();
    //   });
  },
  mounted: function () {},
};
</script>

<style scoped>
.btn {
  border: 1px solid #569bb1 !important;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?69033a24